var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { cols: "12", id: "main_content_minwidthset" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0 pl-3 pr-3",
              attrs: { align: "center", id: "header_height" },
            },
            [
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _c(
                        "router-link",
                        {
                          staticStyle: { color: "transparent" },
                          attrs: {
                            to: { path: _vm.$routerHistory.previous().path },
                          },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: {
                                color: "#08B0FF",
                                "font-size": "1rem",
                                "text-align": "center",
                              },
                              attrs: { cols: "auto", align: "center" },
                            },
                            [_vm._v(" " + _vm._s("UI 테스트") + " ")]
                          ),
                        ],
                        1
                      ),
                      _c("v-img", {
                        staticClass: "ma-0 pa-0 mr-3",
                        attrs: {
                          "max-height": "50px",
                          "max-width": "1.5rem",
                          src: require("@/assets/images/history_arrow.png"),
                        },
                      }),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                        [_vm._v(" " + _vm._s(_vm.title) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }